import axios from 'axios';
import { cacheAdapterEnhancer } from 'axios-extensions';

const client = axios.create({
    withCredentials: true,
    baseURL: process.env.REACT_APP_API_URL,
    adapter: cacheAdapterEnhancer(axios.defaults.adapter),
});

client.defaults.paramsSerializer = (paramObj) => {
    const params = new URLSearchParams();
    Object.keys(paramObj).forEach((key) => {
        if ({}.hasOwnProperty.call(paramObj, key)) {
            params.append(key, paramObj[key]);
        }
    });
    return params.toString();
};

client.interceptors.request.use(config => {
    /* JWT 토큰 */
    const userAccessToken = localStorage.getItem('accessToken');
    if (userAccessToken) {
        config.headers['Authorization'] = `Bearer ${userAccessToken}`;
    }

    return config;
})
let isTokenRefreshing = false;
client.interceptors.response.use((response) => {
    const { success, message } = response.data;
    if (success && message) {
        console.log(message)
    }
    return response;
}, async (error) => {
    const { config, response: { status } } = error;
    const originalRequest = config;
    // console.log(config, status, error.response);
    if (status === 401) {
        if (!isTokenRefreshing) {
            isTokenRefreshing = true;
            const { data } = await client.post("/kognr/refresh", {
                rk: localStorage.getItem('refreshToken')
            });
            // console.log(data);
            if(data.error){
                document.location.replace("/");
                return Promise.reject();
            }
            const { access_token: accessToken } = data.payload;
            // if(accessToken === undefined) {
            //     document.location.replace("/");
            //     return Promise.reject();
            // }
            if (data.success) {  // 토큰 리프레시 성공 시, 헤더를 업데이트하고 원래의 요청을 재시도
                localStorage.setItem('accessToken', accessToken);
                client.defaults.headers.common.Authorization = `Bearer ${data.payload.access_token}`;
                originalRequest.headers.Authorization = `Bearer ${data.payload.access_token}`;
                isTokenRefreshing = false;
                return client(originalRequest);
            }
            else{
                document.location.replace("/");
                return Promise.reject();
            }
        }
        document.location.replace("/");
        return Promise.reject();
    }
    return error.response;
});

export default client;

